import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import ShareIcon from "@mui/icons-material/Share";
import PeopleIcon from "@mui/icons-material/People";
import { Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const TopHeader = ({
  setSidebarColActive,
  headerParams,
  setDarkBackground,
  setCustomBookmarkPopup,
  setUserPopup,
  setRenamePopup,
  checkParent,
  setSharePopup,
  handleDelete,
}) => {
  return (
    <div className="right-header">
      <div className="flex">
        <MenuIcon
          className="mr-1 hd-ds"
          onClick={() => setSidebarColActive(true)}
        />
        <h2 className="flex">
          {headerParams.title}
          {headerParams.isShared_ysn && (
            <Tooltip title="Shared Collection">
              <PeopleIcon className="ml-1" />
            </Tooltip>
          )}
        </h2>
      </div>

      <div className="actions">
        <Tooltip title="Add external source to Collection">
          <div
            onClick={() => {
              setDarkBackground(true);
              setCustomBookmarkPopup(true);
            }}
            className="btn-text"
          >
            <AddIcon />
            <p>Add External</p>
          </div>
        </Tooltip>
        {headerParams.isShared_ysn && (
          <Tooltip title="See who has access to this Collection">
            <div
              onClick={() => {
                setUserPopup((prev) => !prev);
                setDarkBackground(true);
              }}
              className="btn-text"
            >
              <PeopleIcon className="btn-text mr-1" />
              <p>User List</p>
            </div>
          </Tooltip>
        )}
        <Tooltip title="Rename this collection.">
          <div
            onClick={() => {
              setRenamePopup((prev) => !prev);
              setDarkBackground(true);
            }}
            className="btn-text"
          >
            <EditIcon />
            <p>Rename</p>
          </div>
        </Tooltip>
        {checkParent() && (
          <Tooltip title="Give access to others on your team">
            <div
              onClick={() => {
                setSharePopup((prev) => !prev);
                setDarkBackground(true);
              }}
              className="btn-text"
            >
              <ShareIcon />
              <p>Share</p>
            </div>
          </Tooltip>
        )}
        <Tooltip title="Delete this Collection">
          <div
            onClick={() => {
              setDarkBackground(true);
              handleDelete();
            }}
            className="btn-text"
          >
            <DeleteOutlineIcon />
            <p>Delete</p>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default TopHeader;
